import React from 'react';
import { IGameFeed } from '@pvplevelup/core/dist/queries/game/gameFeed';
import { IUser } from '@pvplevelup/core/dist/interfaces/IUser';
import { ProfileGames } from 'components/Profile/ProfileGames';

interface Props {
  user: IUser | undefined | null;
  gameFeed: IGameFeed | undefined;
  fetchMoreRecords: ()=>void;
}

/** The user page's Game History tab; MMR is the account's. */
const UserGames: React.FC<Props> = ({gameFeed,fetchMoreRecords}) => {
  return (
    <ProfileGames gameFeed={gameFeed} fetchMoreRecords={fetchMoreRecords} byUser />
  );
};

export {UserGames};
